// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"566":"3ea2983c","755":"9dd67c78","769":"ac23f41b","974":"7e8e854a"}[chunkId] + ".chunk.css";
};